{
  "AUTOMATION": {
    "HEADER": "Automatizare",
    "DESCRIPTION": "Automation can replace and streamline existing processes that require manual effort, such as adding labels and assigning conversations to the most suitable agent. This allows the team to focus on their strengths while reducing time spent on routine tasks.",
    "LEARN_MORE": "Learn more about automation",
    "HEADER_BTN_TXT": "Adaugă Regulă de Automatizare",
    "LOADING": "Preluarea regulilor de automatizare",
    "ADD": {
      "TITLE": "Adaugă Regulă de Automatizare",
      "SUBMIT": "Creeaza",
      "CANCEL_BUTTON_TEXT": "Renunță",
      "FORM": {
        "NAME": {
          "LABEL": "Nume Regulă",
          "PLACEHOLDER": "Introduceți numele regulii",
          "ERROR": "Numele este obligatoriu"
        },
        "DESC": {
          "LABEL": "Descriere",
          "PLACEHOLDER": "Introduceți descrierea regulii",
          "ERROR": "Descrierea este obligatorie"
        },
        "EVENT": {
          "LABEL": "Eveniment",
          "PLACEHOLDER": "Vă rugăm să selectaţi un tip",
          "ERROR": "Evenimentul este necesar"
        },
        "PHASE": {
          "LABEL": "Fază"
        },
        "ORDER": {
          "LABEL": "Ordine",
          "ERROR": "Ordinea este obligatorie"
        },
        "CONDITIONS": {
          "LABEL": "Condiții"
        },
        "ACTIONS": {
          "LABEL": "Actiuni"
        }
      },
      "CONDITION_BUTTON_LABEL": "Adauga condiţie",
      "ACTION_BUTTON_LABEL": "Adăugare acțiune",
      "API": {
        "SUCCESS_MESSAGE": "Regulă de automatizare adăugată cu succes",
        "ERROR_MESSAGE": "Nu s-a putut crea o regulă de automatizare, Încercați din nou mai târziu"
      }
    },
    "LIST": {
      "404": "Nu s-au găsit reguli de automatizare",
      "TABLE_HEADER": {
        "PHASE": "Fază",
        "ORDER": "Ordine",
        "NAME": "Nume",
        "DESCRIPTION": "Descriere",
        "ACTIVE": "Activ",
        "CREATED_ON": "Creat in",
        "WAIT": "Așteptare"
      },
      "TABS": {
        "ALL": "Toate",
        "INSTANT": "La eveniment",
        "DELAYED": "Cu întârziere"
      },
      "WAITS": "Așteaptă {duration}"
    },
    "DELETE": {
      "TITLE": "Ștergeți regula de automatizare",
      "SUBMIT": "Şterge",
      "CANCEL_BUTTON_TEXT": "Renunță",
      "CONFIRM": {
        "TITLE": "Confirmă ștergerea",
        "MESSAGE": "Sigur doriți să ștergeți ",
        "YES": "Da, șterge ",
        "NO": "Nu, păstreaza "
      },
      "API": {
        "SUCCESS_MESSAGE": "Regula de automatizare ștearsă cu succes",
        "ERROR_MESSAGE": "Nu a putut șterge o regulă de automatizare, Încercați din nou mai târziu"
      }
    },
    "EDIT": {
      "TITLE": "Editarea regulii de automatizare",
      "SUBMIT": "Actualizare",
      "CANCEL_BUTTON_TEXT": "Renunță",
      "API": {
        "SUCCESS_MESSAGE": "Regula de automatizare actualizată cu succes",
        "ERROR_MESSAGE": "Nu s-a putut actualiza regula de automatizare, Încercați din nou mai târziu"
      }
    },
    "CLONE": {
      "TOOLTIP": "Clonare",
      "API": {
        "SUCCESS_MESSAGE": "Automatizare clonată cu succes",
        "ERROR_MESSAGE": "Nu s-a putut clona regula de automatizare, Încercați din nou mai târziu"
      }
    },
    "FORM": {
      "EDIT": "Editare",
      "CREATE": "Creeaza",
      "DELETE": "Şterge",
      "CANCEL": "Renunță",
      "RESET_MESSAGE": "Modificarea tipului de eveniment va reseta condițiile și evenimentele pe care le-ați adăugat mai jos"
    },
    "CONDITION": {
      "DELETE_MESSAGE": "Trebuie să aveți atleast o condiție pentru a salva",
      "CONTACT_CUSTOM_ATTR_LABEL": "Atribute de contact personalizate",
      "CONVERSATION_CUSTOM_ATTR_LABEL": "Atribute personalizate pentru conversație"
    },
    "ACTION": {
      "DELETE_MESSAGE": "Trebuie să aveți atleast o acțiune pentru a salva",
      "TEAM_MESSAGE_INPUT_PLACEHOLDER": "Introduceți mesajul aici",
      "TEAM_DROPDOWN_PLACEHOLDER": "Selectați echipe",
      "EMAIL_INPUT_PLACEHOLDER": "Enter email",
      "URL_INPUT_PLACEHOLDER": "Enter URL",
      "SENDER_DROPDOWN_PLACEHOLDER": "Selectați inboxul de email și adresa expeditorului",
      "SUBJECT_INPUT_PLACEHOLDER": "Subiectul emailului",
      "SMS_INBOX_DROPDOWN_PLACEHOLDER": "Selectați inboxul SMS din care se trimite",
      "SMS_MESSAGE_INPUT_PLACEHOLDER": "Introduceți textul SMS-ului",
      "SMS_COUNTER": "{length}/{limit} caractere, {segments} SMS (înainte de completarea variabilelor)"
    },
    "TOGGLE": {
      "ACTIVATION_TITLE": "Activați regula de automatizare",
      "DEACTIVATION_TITLE": "Dezactivați regula de automatizare",
      "ACTIVATION_DESCRIPTION": "Această acțiune va activa regula de automatizare \"{automationName}\". Sunteți sigur că doriți să continuați?",
      "DEACTIVATION_DESCRIPTION": "Această acțiune va dezactiva regula de automatizare \"{automationName}\". Sunteți sigur că doriți să continuați?",
      "ACTIVATION_SUCCESFUL": "Regulă de automatizare activată cu succes",
      "DEACTIVATION_SUCCESFUL": "Regula de automatizare dezactivată cu succes",
      "ACTIVATION_ERROR": "Nu s-a putut activa automatizarea, încercați din nou mai târziu",
      "DEACTIVATION_ERROR": "Nu s-a putut dezactiva automatizarea, încercați din nou mai târziu",
      "CONFIRMATION_LABEL": "Da",
      "CANCEL_LABEL": "Nu"
    },
    "ATTACHMENT": {
      "UPLOAD_ERROR": "Nu s-a putut încărca atașamentul, încercați din nou",
      "LABEL_IDLE": "Fişier ataşat",
      "LABEL_UPLOADING": "Încărcare...",
      "LABEL_UPLOADED": "Încărcare reușită",
      "LABEL_UPLOAD_FAILED": "Încărcare eșuată"
    },
    "ERRORS": {
      "ATTRIBUTE_KEY_REQUIRED": "Attribute key is required",
      "FILTER_OPERATOR_REQUIRED": "Filter operator is required",
      "VALUE_REQUIRED": "Este necesară o valoare validă",
      "VALUE_MUST_BE_BETWEEN_0_AND_998": "Valoarea trebuie să fie între 0 și 998",
      "ACTION_PARAMETERS_REQUIRED": "Action parameters are required",
      "ATLEAST_ONE_CONDITION_REQUIRED": "At least one condition is required",
      "ATLEAST_ONE_ACTION_REQUIRED": "At least one action is required",
      "ORDER_REQUIRED": "Ordinea este obligatorie",
      "ORDER_MUST_BE_AT_LEAST_ONE": "Ordinea trebuie să fie cel puțin 1",
      "VALUE_MUST_BE_BETWEEN_1_AND_998": "Value must be between 1 and 998"
    },
    "ACTION_NOTICES": {
      "SKIP_AUTO_PRIORITY": "Această acțiune funcționează doar când faza regulii este setată la „Înainte de etichetare”.",
      "SKIP_AUTO_LABELING": "Această acțiune funcționează doar când faza regulii este setată la „Înainte de etichetare”.",
      "MOVE_CONVERSATION_TO_INBOX": "Doar conversațiile de email și de chat web pot fi mutate într-un inbox de email, un chat web doar dacă contactul are o adresă de email. Altfel, conversația nu este mutată și în schimb se adaugă o notă privată.",
      "SEND_MESSAGE_IN_NEW_CONVERSATION": "Începe o conversație nouă cu contactul în inboxul de email selectat, îi trimite mesajul prin email și rezolvă conversația. Acest lucru se întâmplă de fiecare dată când rulează regula. Dacă contactul nu are o adresă de email, nu se trimite nimic și în schimb se adaugă o notă privată.",
      "SEND_SMS_IN_NEW_CONVERSATION": "Începe o conversație nouă cu contactul în inboxul SMS selectat, îi trimite mesajul prin SMS și rezolvă conversația. Acest lucru se întâmplă de fiecare dată când rulează regula. Mesajul este text simplu, fără atașamente. Dacă contactul nu are număr de telefon, nu se trimite nimic și în schimb se adaugă o notă privată."
    },
    "NOTICES": {
      "AI_PROMPT": "Fiecare evaluare individuală este taxată.",
      "INCOMING_MESSAGES_COUNT": "Se referă la numărul de mesaje primite în conversație.",
      "OUTGOING_MESSAGES_COUNT": "Se referă la numărul de mesaje trimise în conversație."
    },
    "PHASE": {
      "BEFORE_LABELING": "Înainte de etichetare",
      "AFTER_LABELING": "După etichetare"
    },
    "NONE_OPTION": "Nimic",
    "MESSAGE_TYPE_VALUES": {
      "INCOMING": "Mesaj primit",
      "OUTGOING": "Mesaj trimis",
      "PRIVATE": "Notă privată",
      "AI_SUMMARY": "Rezumat AI"
    },
    "YES_NO_VALUES": {
      "YES": "Da",
      "NO": "Nu"
    },
    "MESSAGE_SOURCE_TYPE_VALUES": {
      "FACEBOOK_MESSENGER": "Facebook Messenger",
      "INSTAGRAM_DM": "Mesaj direct Instagram",
      "FACEBOOK_COMMENT": "Comentariu Facebook"
    },
    "EVENTS": {
      "CONVERSATION_CREATED": "Conversație creată",
      "CONVERSATION_UPDATED": "Conversație actualizată",
      "MESSAGE_CREATED": "Mesaj creat",
      "CONVERSATION_OPENED": "Conversație deschisă",
      "CONVERSATION_RESOLVED": "Conversație rezolvată",
      "PHONE_CALL_FINISHED": "Apel încheiat"
    },
    "ACTIONS": {
      "ASSIGN_AGENT": "Atribuie unui agent",
      "ASSIGN_TEAM": "Atribuie unei echipe",
      "ADD_LABEL": "Adaugă o etichetă",
      "REMOVE_LABEL": "Elimină o etichetă",
      "SEND_EMAIL_TO_TEAM": "Trimite un email către echipă",
      "SEND_EMAIL_TRANSCRIPT": "Trimite transcrierea pe email",
      "SEND_EMAIL_TRANSCRIPT_WITH_DETAILS": "Trimite transcrierea detaliată pe email",
      "MUTE_CONVERSATION": "Dezactivează notificările pentru conversație",
      "SNOOZE_CONVERSATION": "Amână conversația",
      "RESOLVE_CONVERSATION": "Rezolvă conversația",
      "OPEN_CONVERSATION": "Deschide conversația",
      "SEND_WEBHOOK_EVENT": "Trimite eveniment webhook",
      "SEND_ATTACHMENT": "Trimite atașament",
      "SEND_MESSAGE": "Trimite un mesaj",
      "ADD_NOTE": "Adaugă o notă",
      "CHANGE_PRIORITY": "Schimbă prioritatea",
      "ADD_SLA": "Adaugă SLA",
      "SKIP_AUTO_PRIORITY": "Omite prioritizarea automată",
      "SKIP_AUTO_LABELING": "Omite etichetarea automată",
      "AUTO_TRANSLATE": "Tradu mesajul",
      "AUTO_TRANSLATE_CONVERSATION": "Tradu conversația",
      "MOVE_CONVERSATION_TO_INBOX": "Mută conversația în inbox",
      "SEND_MESSAGE_IN_NEW_CONVERSATION": "Trimite un mesaj într-o conversație nouă",
      "SEND_SMS_IN_NEW_CONVERSATION": "Trimite SMS într-o conversație nouă",
      "STOP_PROCESSING_RULES": "Oprește procesarea regulilor"
    },
    "ATTRIBUTES": {
      "EXTENSION": "Interior apelat",
      "WORKING_HOURS": "În program de lucru",
      "AGENT_REPLIED": "Un agent a răspuns de la schimbarea stării",
      "AI_FILTER": "Filtru AI",
      "MESSAGE_TYPE": "Tip mesaj",
      "MESSAGE_CONTAINS": "Conținut mesaj",
      "EMAIL": "Email",
      "INBOX": "Inbox",
      "CHANNEL_TYPE": "Tip de inbox",
      "CONVERSATION_LANGUAGE": "Limba conversației",
      "PHONE_NUMBER": "Număr de telefon",
      "STATUS": "Stare",
      "BROWSER_LANGUAGE": "Limba browserului",
      "MAIL_SUBJECT": "Subiect email",
      "COUNTRY_NAME": "Țară",
      "MARKETPLACE_COUNTRY": "Țara marketplace-ului",
      "REFERER_LINK": "Link referrer",
      "ASSIGNEE_NAME": "Atribuit lui",
      "TEAM_NAME": "Echipă",
      "PRIORITY": "Prioritate",
      "CALL_DIRECTION": "Direcție apel",
      "MISSED_CALL": "Apel ratat",
      "MISSED_CALL_COUNT": "Număr de apeluri ratate",
      "MESSAGE_SOURCE_TYPE": "Tip sursă mesaj",
      "INCOMING_MESSAGE_COUNT": "Număr de mesaje primite",
      "OUTGOING_MESSAGE_COUNT": "Număr de mesaje trimise",
      "LABEL": "Etichetă",
      "EMAIL_RECIPIENTS": "Destinatar email",
      "EMAIL_AUTO_REPLY": "Emailul este un răspuns automat",
      "ATTACHMENT_EXTENSION": "Extensie atașament"
    },
    "WAIT": {
      "RUN_LABEL": "Execută acțiunile",
      "INSTANT": "La eveniment",
      "DELAYED": "Cu întârziere",
      "TRIGGER_LABEL": "Așteaptă până când",
      "TRIGGERS": {
        "CONVERSATION_STATUS": "O conversație rămâne într-o stare",
        "CUSTOMER_UNRESPONSIVE": "Clientul nu îi răspunde unui agent",
        "AGENT_UNRESPONSIVE": "Clientul nu primește răspuns de la un agent"
      },
      "STATUS_LABEL": "Stare",
      "STATUSES": {
        "OPEN": "Deschisă",
        "PENDING": "În așteptare",
        "SNOOZED": "Amânată",
        "RESOLVED": "Rezolvată"
      },
      "DELAY_LABEL": "Timp de așteptare",
      "DELAY_ERROR": "Introduceți un timp de așteptare între 1 minut și 30 de zile",
      "DURATION": {
        "MINUTES": "{count} min",
        "HOURS": "{count} h",
        "DAYS": "{count} z"
      },
      "EXPLANATION": {
        "CONVERSATION_STATUS": "Acțiunile rulează când o conversație este în starea {status} de {duration}. O schimbare de stare înainte le anulează. Etichetele, programul de lucru și răspunsurile agenților sunt verificate la încheierea așteptării.",
        "CUSTOMER_UNRESPONSIVE": "Acțiunile rulează când clientul nu a răspuns de {duration} la mesajul unui agent. Un răspuns al clientului le anulează; un mesaj nou al agentului repornește așteptarea.",
        "AGENT_UNRESPONSIVE": "Acțiunile rulează când clientul așteaptă de {duration} fără răspuns de la un agent. Un răspuns al agentului le anulează."
      }
    }
  }
}
